module.exports = __webpack_public_path__ + "static/media/photo_020.d19a7b21.JPG";